module.exports = __webpack_public_path__ + "img/comparer-purple-shape.58349554.svg";